import { useEffect } from "react";
import { useAutoArchive } from "@/hooks/useAutoArchive";

export function AutoArchiveService(): null {
  const { scheduleAutoArchive } = useAutoArchive();

  useEffect(() => {
    // Démarrer le service d'archivage automatique
    console.log('🚀 Service d\'archivage automatique démarré');
    scheduleAutoArchive();
  }, [scheduleAutoArchive]);

  return null; // Ce composant n'affiche rien
}